import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import WorkstreamValidations from 'scaleflow/validators/workstream';

export interface QuickAddsWorkstreamSignature {
  Args: {
    isOpen?: boolean;
    initiative?: any;
    handleFormDismiss?: () => void;
    onItemSaved?: (workstream: any) => void;
  };
  Blocks: {
    default: [];
  };
  Element: null;
}

export default class QuickAddsWorkstreamComponent extends Component<QuickAddsWorkstreamSignature> {
  @service declare store: any;

  workstream = {
    title: '',
  };
  workstreamValidations = WorkstreamValidations;

  @action
  async onSubmit(changeset: any, e: Event) {
    e.preventDefault();
    try {
      await changeset.validate();
      if (changeset.isInvalid) {
        console.debug(changeset.errors);
        return;
      }
      const workstream = this.store.createRecord('workstream', {
        title: changeset.title,
        initiative: this.args.initiative,
      });
      await workstream.save();
      this.args?.onItemSaved?.(workstream);
      this.handleModalDismiss();
    } catch (err) {
      console.log(err);
    }
  }

  @action
  handleModalDismiss() {
    this.args?.handleFormDismiss?.();
  }
}
